import styled from 'styled-components';

export const ThumbBottom = styled.div`
  position: absolute;
  top: 0;
  left: auto;

  width: 96%;
  height: 65vh;

  border-radius: 32px;

  background: radial-gradient(
      80% 70% at 70% 100%,
      rgba(242, 125, 180, 0.5) 0%,
      rgba(242, 125, 180, 0) 70%
    ),
    radial-gradient(
      80% 70% at 30% 100%,
      rgba(76, 148, 255, 0.5) 0%,
      rgba(76, 148, 255, 0) 70%
    );

  z-index: 0;

  @media (max-width: 1366px) {
    width: 98%;
  }

  @media (max-height: 768px) {
    height: 95vh;

    background: radial-gradient(
        70% 50% at 70% 100%,
        rgba(242, 125, 180, 0.6) 0%,
        rgba(242, 125, 180, 0) 70%
      ),
      radial-gradient(
        70% 50% at 30% 100%,
        rgba(76, 148, 255, 0.6) 0%,
        rgba(76, 148, 255, 0) 70%
      );
  }

  @media (max-width: 500px) {
    border-radius: 16px;

    height: 90vh;

    background: radial-gradient(
        80% 55% at 70% 100%,
        rgba(242, 125, 180, 0.6) 0%,
        rgba(242, 125, 180, 0) 70%
      ),
      radial-gradient(
        80% 55% at 30% 100%,
        rgba(76, 148, 255, 0.6) 0%,
        rgba(76, 148, 255, 0) 70%
      );
  }
`;

export const ThumbTop = styled.div`
  width: 100%;
  height: 18rem;

  position: absolute;
  top: 0;
  left: 0;

  background: radial-gradient(
      40% 45% at 60% -5%,
      rgba(242, 125, 180, 0.4) 0%,
      rgba(242, 125, 180, 0) 63.54%
    ),
    radial-gradient(
      40% 45% at 40% -5%,
      rgba(76, 148, 255, 0.4) 0%,
      rgba(76, 148, 255, 0) 65.63%
    );

  @media (max-width: 500px) {
    background: radial-gradient(
        55% 30% at 60% -5%,
        rgba(242, 125, 180, 0.4) 0%,
        rgba(242, 125, 180, 0) 63.54%
      ),
      radial-gradient(
        55% 30% at 40% -5%,
        rgba(76, 148, 255, 0.4) 0%,
        rgba(76, 148, 255, 0) 65.63%
      );
  }
`;
